import { render, staticRenderFns } from "./auctionPackagePublicExchangeToggle.vue?vue&type=template&id=8766f680&lang=pug"
import script from "./auctionPackagePublicExchangeToggle.vue?vue&type=script&lang=js"
export * from "./auctionPackagePublicExchangeToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports